import { render, staticRenderFns } from "./PortalViewsReport.vue?vue&type=template&id=3926a2e6&scoped=true"
import script from "./PortalViewsReport.vue?vue&type=script&lang=js"
export * from "./PortalViewsReport.vue?vue&type=script&lang=js"
import style0 from "./PortalViewsReport.vue?vue&type=style&index=0&id=3926a2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3926a2e6",
  null
  
)

export default component.exports